<template>
  <section class="deliverycreate">
    <!-- Header form -->
    <f-card class="header">
      <section>
        <div class="row wrap">
          <label class="label-group"><span class="mandatory-label">Fournisseur</span>
            <!-- delivery.id is not exactly a boolean,
            therefore !!delivery.id converts it -->
            <ab-dropdown-input
              ref="dropdown"
              v-model="delivery.supplier"
              :options="suppliers"
              :disabled="!!delivery.id"
              @create:new="newSupplier"></ab-dropdown-input>
          </label>
          <div class="label-group"><span class="mandatory-label">Date de livraison</span>
            <datepicker
              class="f-datepicker"
              :monday-first="true"
              @input="delivery.updated = true;"
              v-model="delivery.deliveryDate"
              :language="fr"></datepicker>
          </div>
          <label class="label-group">
            <span class="mandatory-label">N° bon de livraison</span>
            <ab-input @focus="delivery.updated = true;" v-model="delivery.deliveryNumber"></ab-input>
          </label>
        </div>
      </section>
    </f-card>
    <!-- Delivery input -->
    <form class="input-form" @submit.prevent="addRow">
      <f-table class="input-table">
        <template slot="colgroup">
          <col class="code">
          <col class="label">
          <col class="quantity">
          <col class="price">
          <col class="total">
          <col class="add">
        </template>
        <template slot="thead">
          <th>Code</th>
          <th>Désignation / Familles / Labels & origines</th>
          <th class="right">Qté / Unité</th>
          <th class="right">PU HT</th>
          <th class="right">Total HT</th>
          <th></th>
        </template>
        <template slot="tbody">
          <tr class="input-row">
            <td>
              <div class="col"><ab-input
                id="code-input"
                class="mandatory"
                label="Code"
                v-model="code"
                :tabindex="1"
                :disabled="isDisabled"
                @blur="searchProduct"></ab-input></div>
            </td>
            <td>
              <div class="col">
                <ab-input class="mandatory" label="Désignation" v-model="label" :tabindex="1" :disabled="isDisabled"></ab-input>
                <div class="flex flex-space">
                  <f-select
                    class="familly-select mandatory"
                    :disabled="isDisabled"
                    group-values="Subfamily"
                    group-label="label"
                    placeholder="Familles"
                    :limitText="limitText"
                    :showLabels="false"
                    trackBy="id"
                    label="label"
                    v-model="familly"
                    :tabindex="2"
                    :options="families"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                  <f-select
                    class="labels-origins"
                    :disabled="isDisabled"
                    :multiple="true"
                    :close-on-select="false"
                    group-values="options"
                    group-label="group"
                    placeholder="Labels & origines"
                    :limit="0"
                    :limitText="limitText"
                    :showLabels="false"
                    trackBy="id"
                    label="label"
                    v-model="labelAndOrigin"
                    :tabindex="2"
                    :options="computedLabelAndOrigin"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                </div>
              </div>
            </td>
            <td>
              <div class="col">
                <div class="qte-packaging row">
                  <!-- FIXME : Re sync on blur if same values -->
                  <ab-input class="mandatory input-quantity" label="Qté" type="number" v-model="quantity_ordered" :tabindex="1" :disabled="isDisabled" @input="syncQty()"></ab-input>
                  <f-select
                    class="select-packaging mandatory"
                    placeholder="Unité"
                    trackBy="id"
                    label="label"
                    :showLabels="false"
                    v-model="packaging"
                    :options="packagings"
                    :tabindex="1"
                    :disabled="isDisabled"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                </div>
                <div class="weight flex flex-space">
                  <ab-input class="mandatory" label="Qté reçue" type="number" v-model="quantity_received" :tabindex="2" :disabled="isDisabled" @input="() => unsyncQty = true"></ab-input>
                  <span class="lot">Lot N°</span><ab-input class="lot" :disabled="isDisabled" v-model="package_number" :tabindex="2"></ab-input>
                </div>
              </div>
            </td>
            <td>
              <!-- FIXME : Move 1px up -->
              <div class="col">
                <div class="price flex flex-space">
                  <ab-input class="align-right" type="number" v-model="price" :tabindex="1" :disabled="isDisabled"></ab-input><span>&nbsp;€</span>
                </div>
                <div class="price flex flex-space">
                  <f-select
                    class="select-price"
                    :disabled="isDisabled"
                    placeholder="TVA"
                    :showLabels="false"
                    trackBy="id"
                    label="percentage"
                    v-model="tax"
                    :tabindex="2"
                    :options="taxes"><span slot="noResult">Aucun element trouvé.</span></f-select>
                  <span>&nbsp;%</span>
                </div>
              </div>
            </td>
            <td class="right">
              <div class="col">
                <div class="price">{{ computePriceHT() | currency }}</div>
                <!-- <div class="total-price">{{ computePrice() | currency }} TTC</div> -->
              </div>
            </td>
            <td><button class="action-btn add-btn" :disabled="isDisabled"><ab-icon icon="add" iconset="delivery"></ab-icon></button></td>
          </tr>
        </template>
      </f-table>
      <div class="loading" v-if="loading">
        <f-loader :loading="loading"></f-loader>
      </div>
    </form>
    <!-- Delivery row list -->
    <form :class="items.length > 0 ? 'delivered-items': ''" @submit.prevent="handleSubmit">
      <f-table>
        <template slot="colgroup">
          <col class="code">
          <col class="label">
          <col class="quantity">
          <col class="price">
          <col class="total">
          <col class="add">
        </template>
        <template slot="tbody">
          <tr class="input-row" v-for="(item, index) in filteredItems" :key="index">
            <td class="code">
              <div class="col">
                <ab-input id="code-input"
                  v-model="item.code"
                  :tabindex="(index + 1) * 2 + 1"
                  @blur="searchProduct(item)"
                  @focus="$set(item, 'updated', true)"></ab-input>
              </div>
            </td>
            <td>
              <div class="col">
                <ab-input
                  v-model="item.label"
                  :tabindex="(index + 1) * 2 + 1"
                  @focus="$set(item, 'updated', true)"></ab-input>
                <div class="flex flex-space">
                  <f-select
                    class="familly-select"
                    group-values="Subfamily"
                    group-label="label"
                    placeholder="Familles"
                    :limitText="limitText"
                    :showLabels="false"
                    trackBy="id"
                    label="label"
                    v-model="item.familly"
                    :options="families"
                    :tabindex="(index + 1) * 2 + 2"
                    @open="$set(item, 'updated', true)"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                  <f-select
                    class="labels-origins"
                    :multiple="true"
                    :close-on-select="false"
                    group-values="options"
                    group-label="group"
                    placeholder="Labels & origines"
                    :limit="0"
                    :limitText="limitText"
                    :showLabels="false"
                    trackBy="id"
                    label="label"
                    v-model="item.labelAndOrigin"
                    :tabindex="(index + 1) * 2 + 2"
                    :options="computedLabelAndOrigin"
                    @open="$set(item, 'updated', true)"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                </div>
              </div>
            </td>
            <td>
              <div class="col">
                <div class="qte-packaging row">
                  <ab-input
                    class="input-quantity"
                    label="Qté"
                    type="number"
                    v-model="item.quantity_ordered"
                    :tabindex="(index + 1) * 2 + 1"
                    @input="syncQty(item)"
                    @focus="$set(item, 'updated', true)"></ab-input>
                  <f-select
                    class="select-packaging"
                    placeholder="Unité"
                    trackBy="id"
                    label="label"
                    :showLabels="false"
                    v-model="item.packaging"
                    :tabindex="(index + 1) * 2 + 1"
                    :options="packagings"
                    @open="$set(item, 'updated', true)"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                </div>
                <div class="weight flex flex-space">
                  <ab-input
                    label="Qté reçue"
                    type="number"
                    v-model="item.quantity_received"
                    :tabindex="(index + 1) * 2 + 2"
                    :disabled="isDisabled"
                    @input="() => item.unsyncQty = true"
                    @focus="$set(item, 'updated', true)"></ab-input>
                  <span class="lot">Lot N°</span>
                  <ab-input class="lot" v-model="item.package_number" :tabindex="(index + 1) * 2 + 2" @focus="$set(item, 'updated', true)"></ab-input>
                </div>
              </div>
            </td>
            <td>
              <div class="col">
                <div class="price flex flex-space">
                  <ab-input class="align-right" type="number" v-model="item.price" :tabindex="(index + 1) * 2 + 1" @focus="$set(item, 'updated', true)"></ab-input><span>&nbsp;€</span>
                </div>
                <div class="price flex flex-space">
                  <f-select
                    class="select-price"
                    placeholder="TVA"
                    :showLabels="false"
                    trackBy="id"
                    label="percentage"
                    v-model="item.tax"
                    :tabindex="(index + 1) * 2 + 2"
                    :options="taxes"
                    @open="$set(item, 'updated', true)"
                    ><span slot="noResult">Aucun element trouvé.</span></f-select>
                  <span>&nbsp;%</span>
                </div>
              </div>
            </td>
            <td class="right">
              <div class="col">
                <div class="price">{{ computeItemPriceHT(item) | currency }}</div>
              </div>
            </td>
            <td>
              <div class="col">
                <button class="action-btn remove-btn" type="button" @click="removeRow(item)"><ab-icon icon="remove" iconset="delivery"></ab-icon></button>
              </div>
            </td>
          </tr>
        </template>
      </f-table>
      <section class="totals flex flex-right">
        <div class="ctn">
          <div class="flex flex-right">
            <div class="label">Total livraison <span class="tax">HT</span></div>
            <div class="amount">{{ totalHT | currency }}</div>
          </div>
          <div class="flex flex-right">
            <div class="label">Total livraison <span class="tax">TTC</span></div>
            <div class="amount">{{ total | currency }}</div>
          </div>
          <div class="footer flex flex-space">
            <ab-button :disabled="filteredItems.length < 1" class="primary" type="button" @click.native="saveAndReset">{{ displaySaveAndNew }}</ab-button>
            <router-link class="btn-action" :to="{ name: 'DeliveryList' }">Retour</router-link>
          </div>
        </div>
      </section>
    </form>
    <f-modal
      class="modal"
      name="delete-row"
      height="auto"
      @before-open="beforeOpen">
      <f-card>
        <header slot="header">
          <h1>Confirmer la suppression.</h1>
        </header>
        <div class="footer flex flex-right" slot="footer">
          <ab-button @click.native="$modal.hide('delete-row')">Annuler</ab-button>
          <ab-button class="primary danger" @click.native="confirmRemove">Supprimer</ab-button>
        </div>
      </f-card>
    </f-modal>
    <ab-iconset iconset="delivery">
      <g id="add">
        <path d="M13.0315 10.3413L13.0315 5.92159C13.0315 5.15295 12.4551 4.57647 11.6864 4.57647C10.9178 4.57647 10.3413 5.15295 10.3413 5.9216L10.3413 10.3413L5.9216 10.3413C5.15296 10.3413 4.57648 10.9178 4.57648 11.6864C4.57648 12.455 5.15296 13.0315 5.9216 13.0315L10.3413 13.0315L10.3413 17.4512C10.3413 18.2198 10.9178 18.7963 11.6864 18.7963C12.0707 18.7963 12.359 18.7002 12.6472 18.412C12.9354 18.1238 13.0315 17.8355 13.0315 17.4512L13.0315 13.0315L17.4512 13.0315C17.8355 13.0315 18.1238 12.9354 18.412 12.6472C18.7003 12.359 18.7963 12.0707 18.7963 11.6864C18.7963 10.9178 18.2199 10.3413 17.4512 10.3413L13.0315 10.3413Z"/>
      </g>
      <g id="remove">
        <path d="M14.1 12L17.55 8.55C18.15 7.95 18.15 7.05 17.55 6.45C16.95 5.85 16.05 5.85 15.45 6.45L12 9.9L8.55 6.45C7.95 5.85 7.05 5.85 6.45 6.45C5.85 7.05 5.85 7.95 6.45 8.55L9.9 12L6.45 15.45C5.85 16.05 5.85 16.95 6.45 17.55C6.75 17.85 7.05 18 7.5 18C7.95 18 8.25 17.85 8.55 17.55L12 14.1L15.45 17.55C15.75 17.85 16.05 18 16.5 18C16.95 18 17.25 17.85 17.55 17.55C18.15 16.95 18.15 16.05 17.55 15.45L14.1 12Z"/>
      </g>
      <g id="save">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V8.41421L15.5858 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289L21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 13C6 12.4477 6.44772 12 7 12H17C17.5523 12 18 12.4477 18 13V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V14H8V21C8 21.5523 7.55228 22 7 22C6.44772 22 6 21.5523 6 21V13Z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 2C7.55228 2 8 2.44772 8 3V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8V3C6 2.44772 6.44772 2 7 2Z"/>
      </g>
    </ab-iconset>
  </section>
</template>

<script>
import AbIconset from '@/components/icon/ab-iconset.vue';
import AbIcon from '@/components/icon/ab-icon.vue';
import FCard from '@/components/layout/card/f-card.vue';
import AbInput from '@/components/form/input/ab-input.vue';
import AbDropdownInput from '@/components/form/input/ab-dropdown-input.vue';
import FTable from '@/components/layout/table/f-table.vue';
import AbButton from '@/components/form/button/ab-button.vue';
import FLoader from '@/components/loader/f-loader.vue';
import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';
import { mapState } from 'vuex';
// Import error message files
import messages from '@/messages/messages.js';
import notification from '@/components/mixins/notification.js';
import { debug } from 'util';
// Initial data state
function initData() {
  return {
    delivery: {
      id: null,
      supplier: null,
      deliveryDate: new Date(),
      deliveryNumber: null,
      updated: false
    },
    newSupplierLabel: null,
    productFound: false,
    code: '',
    label: '',
    familly: '',
    labelAndOrigin: [],
    price: 0,
    tax: '',
    quantity_ordered: null,
    quantity_received: null,
    unsyncQty: false,
    package_number: '',
    packaging: '',
    fingerprint: '',
    items: [],
    itemToDelete: {},
    fr: fr
  };
}

export default {
  name: 'DeliveryCreate',
  components: {
    AbIconset,
    AbIcon,
    FCard,
    AbInput,
    AbDropdownInput,
    FTable,
    AbButton,
    FLoader,
    Datepicker
  },
  mixins: [ notification ],
  props: {
    isEdit: false
  },
  data() {
    return initData();
  },
  async mounted() {
    await this.$store.dispatch('getFamilies');
    await this.$store.dispatch('getLabels');
    await this.$store.dispatch('getOrigins');
    await this.$store.dispatch('getPackagings');
    await this.$store.dispatch('getRoles');
    await this.$store.dispatch('getSuppliers', { page: null, limit: null });
    await this.$store.dispatch('getTaxes');

    // Set initial value
    this.tax = this.taxes.find(tax => tax.percentage == 5.5);

    if (this.isEdit) {
      this.$store.dispatch('getDelivery', {
        client: this.client,
        id: this.$route.params.id
      });
    }
  },
  computed: {
    // State mapping
    ...mapState([ 'client' ]),
    ...mapState({ deliveryData: state => state.deliveries.delivery }),
    ...mapState({ loading: state => state.deliveries.loading }),
    ...mapState({ newSupplierEntity: state => state.suppliers.newEntity }),
    ...mapState({ product: state => state.deliveries.product }),
    ...mapState({ roles: state => state.selectors.roles }),
    ...mapState({ suppliers: state => state.suppliers.suppliers }),

    // Selectors
    ...mapState({ families: state => state.selectors.families }),
    ...mapState({ labels: state => state.selectors.labels }),
    ...mapState({ origins: state => state.selectors.origins }),
    ...mapState({ packagings: state => state.selectors.packagings }),
    ...mapState({ taxes: state => state.selectors.taxes }),

    computedLabelAndOrigin() {
      const labels = this.labels.map(label => ({ ...label, id: `label-${label.id}` }));
      const origins = this.origins.map(origin => ({ ...origin, id: `origin-${origin.id}` }));
      return [
        {
          group: 'Labels',
          options: labels
        }, {
          group: 'Origines',
          options: origins
        }
      ];
    },
    supplierNotExists() {
      return (!this.delivery.supplier) ? !this.newSupplierLabel : null;
    },
    isDisabled() {
      return this.supplierNotExists || !this.delivery.deliveryDate || !this.delivery.deliveryNumber;
    },
    totalHT() {
      if (this.items.length > 0)
        return this.items.map(item => this.computeItemPriceHT(item)).reduce((a, b) => a + b);
      return 0.000;
    },
    /**
     * @see http://www.nuage-web.fr/wp/encyclopedia/methode-de-calcul-du-total-ttc-et-regles-d-arrondi/
     */
    total() {
      if (this.items.length > 0) {
        // Group products by tax group
        // And sum all the (rounded) product by tax group
        const productGrouped = this.taxes.map(tax => {
          let taxGroup = {};
          taxGroup[tax.percentage] = this.items
            .filter(item => item.tax.percentage == tax.percentage)
            .map(item => this.computeItemPriceHT(item))
            .reduce((sum, next) => {
              return Number(sum._toFixed(2)) + Number(next._toFixed(2));
            }, 0);
          return taxGroup;
        });
        // Iterate into taxes and add the percentage
        const total = productGrouped.map(group => {
          const keys = Object.keys(group);
          if (!keys[0]) return;
          const key = keys[0];
          const taxValue = (1 + (Number(key) / 100));
          const value = group[key] * taxValue;

          return Number(value._toFixed(2));
        }).reduce((sum, next) => sum + next, 0);

        return total;
        // return this.items.map(item => this.computeItemPrice(item)).reduce((a, b) => {
        //   return Number(a._toFixed(2)) + Number(b._toFixed(2));
        // });
      }
      return 0.000;
    },
    filteredItems() {
      return this.items;
    },
    displaySaveAndNew() {
      const updated = this.filteredItems.some(item => item.updated) || this.delivery.updated;
      return updated ? "Enregistrer et nouveau" : "Nouveau";
    }
  },
  methods: {
    /**
     * We need to create an async forEach
     * @see https://codeburst.io/javascript-async-await-with-foreach-b6ba62bbf404
     */
    async _asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    syncQty(item) {
      if (item == null && !this.unsyncQty) {
        return this.quantity_received = this.quantity_ordered;
      } else if (!item.unsyncQty) {
        return item.quantity_received = item.quantity_ordered;
      }
    },
    async saveAndReset() {
      const results = [];

      // Save the delivery form if one value may have been updated
      if (this.delivery.updated) {
        const data = await this.saveDelivery();
        results.push(data);
      }

      // Save a delivery item if one value may have been updated
      const updated = this.filteredItems.some(item => item.updated);
      const filteredItems = this.filteredItems.filter(item => item.updated);
      await this._asyncForEach(filteredItems, async item => {
        const data = await this.saveRow(item);
        results.push(data);
      });

      const isError = results.some(result => result === false);
      if (isError) {
        return this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });
      }
      if (this.delivery.updated || updated) {
        this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.updateRowSuccess });
      }

      // Programmatically reset data based on
      // external function
      Object.assign(this.$data, initData());
      this.$refs.dropdown.reset();
      this.$router.push({ name: 'DeliveryCreate', props: { isEdit: false } });
    },
    async newSupplier(value) {
      this.newSupplierLabel = value;
    },
    resetInputsAndFocus() {
      this.code = '';
      this.label = '';
      this.familly = '';
      this.labelAndOrigin = [];
      this.price = 0;
      this.tax = this.taxes.find(tax => tax.percentage == 5.5);
      this.quantity_ordered = null;
      this.quantity_received = null;
      this.unsyncQty = false;
      this.packaging = '';
      this.package_number = '';
      this.fingerprint = '';
      this.productFound = false;

      const input = this.$el.querySelector('#code-input input');
      input.focus();
    },
    removeRow(item) {
      this.$modal.show('delete-row', item);
    },
    confirmRemove() {
      this.$store.dispatch('deleteDeliveryItem', {
        delivery: this.delivery.id,
        deliveryItem: this.itemToDelete,
        client: this.client
      });

      console.info(messages.deliveries.DeliveryCreate.custom.updateRowSuccess);
      this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.updateRowSuccess });

      const index = this.items.indexOf(this.itemToDelete);
      this.items.splice(index, 1);
      this.$modal.hide('delete-row');
    },
    beforeOpen(event) {
      this.itemToDelete = event.params;
    },
    computePriceHT(decimal = 2) {
      return Number(this.price) * this.quantity_ordered;
    },
    computePrice(decimal = 2) {
      if (this.tax == null) this.tax = { percentage: 0 };
      return (Number(this.price) + (this.price * (this.tax.percentage * 0.01))) * this.quantity_ordered;
    },
    computeItemPriceHT(item, decimal = 2) {
      return Number((Number(item.price) * item.quantity_ordered)._toFixed(decimal));
    },
    computeItemPrice(item, decimal = 2) {
      if (item.tax == null) item.tax = { percentage: 0 };
      return (Number(item.price) + (item.price * (item.tax.percentage * 0.01))) * item.quantity_ordered;
    },
    transformLabelAndOrigin(labels, origins) {
      const labelList = labels.map(label => ({ ...label, id: `label-${label.id}` }));
      const originList = origins.map(origin => ({ ...origin, id: `origin-${origin.id}` }));
      return [ ...labelList, ...originList ];
    },
    retrieveLabelAndOrigin(labelAndOrigin) {
      const label = labelAndOrigin.filter(label => (label.id.split('-')[0] && label.id.split('-')[0] == 'label' )).map(label => ({ ...label, id: label.id.split('-')[1] }));
      const origin = labelAndOrigin.filter(origin => (origin.id.split('-')[0] && origin.id.split('-')[0] == 'origin' )).map(origin => ({ ...origin, id: origin.id.split('-')[1] }));

      return {
        label,
        origin,
      };
    },
    limitText(count) {
      return `${count} élément${count > 1?'s':''} sélectionné${count > 1?'s':''}`;
    },
    async saveDelivery() {
      if (!this.delivery.id) return;
      return await this.$store.dispatch('updateDelivery', { ...this.delivery, client: this.client });
    },
    async findProductOrCreate(item) {
      let product = {};

      // handle case where no product was previously finded
      if (!item.code) {
        const labelAndOrigin = this.retrieveLabelAndOrigin(this.labelAndOrigin);
        product = {
          code: this.code,
          product_label: this.label,
          familly: this.familly,
          label: labelAndOrigin.label,
          origin: labelAndOrigin.origin,
          price: this.price,
          tax: !!this.tax ? this.tax : { percentage: 0 },
          quantity_ordered: this.quantity_ordered,
          quantity_received: this.quantity_received,
          packaging: this.packaging,
        };
      } else {
        const labelAndOrigin = this.retrieveLabelAndOrigin(item.labelAndOrigin);
        product = {
          ...item,
          product_label: item.label,
          familly: item.familly,
          label: labelAndOrigin.label,
          origin: labelAndOrigin.origin,
          packaging: item.packaging,
          tax: item.tax
        };
      }

      // If the user try to add a new row, we create a new delivery form. and add the new created product to the delivery form
      if (!this.delivery.id) {
        this.delivery.id =  await this.$store.dispatch('createDelivery', { ...this.delivery, client: this.client });
        if (!this.delivery.id) {
          // Dispatch
          this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });
          return false;
        }
        // Dispatch success
        this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.createSuccess });
      }

      if (!item.code) {
        // If there is no product found for the given code, we create a new product for this supplier
        // If the returned product code or label differ from those typed, we create a new product for this supplier
        const fingerprint = JSON.stringify({
          code: this.code,
          label: this.label,
          familly: this.familly,
          labelAndOrigin: this.labelAndOrigin,
          packaging: this.packaging,
          price: this.price,
          tax: this.tax
        });
        if (!this.productFound || (this.productFound && fingerprint != this.fingerprint)) {
          const id= await this.$store.dispatch('createProduct', { ...product, supplier: this.delivery.supplier });
          product['product'] = { id };
        } else {
          product['product'] = { id: this.product.id };
        }
      } else {
        // We create a finger print for the product as it came from the database
        const fingerprint = JSON.stringify({
          code: item.code,
          label: item.label,
          familly: item.familly,
          labelAndOrigin: item.labelAndOrigin,
          packaging: item.packaging,
          price: item.price,
          tax: item.tax
        });
        if (fingerprint != product.fingerprint) {
          // If the product have changed, we create a new product and make a new finger print
          item.fingerprint = JSON.stringify({
            code: product.code,
            label: product.product_label,
            familly: product.familly,
            labelAndOrigin: product.labelAndOrigin,
            packaging: product.packaging,
            price: product.price,
            tax: product.tax
          });
          // We create a new product, and get it new ID
          product.product.id = await this.$store.dispatch('createProduct', { ...product, supplier: this.delivery.supplier });
        }
      }

      return product;
    },
    async addRow() {
      // Create a new supplier when delivery.supplier is not found
      if(this.newSupplierLabel && this.newSupplierLabel != null && this.delivery.supplier == null) {
        await this.$store.dispatch('createSupplier', { 
          label: this.newSupplierLabel
        });
        console.info(messages.deliveries.DeliveryCreate.custom.createSupplieruccess);
      }

      if (!this.code || !this.label || !this.familly || !this.packaging)
        return this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.mandatory, mode: 'error'});

      const product = await this.findProductOrCreate({});
      if (!product) return this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });

      const item = await this.$store.dispatch('createDeliveryItem', {
        delivery: this.delivery.id,
        deliveryItem: {
          supplier: Number(this.delivery.supplier),
          product: product.product.id,
          price: product.price,
          quantity_ordered : product.quantity_ordered,
          quantity_received: product.quantity_received,
          package_number: this.package_number,
          total: product.price*product.quantity_ordered
        },
        client: this.client
      });
      if (item === false) return this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });

      this.items.unshift({
        id: item.id,
        product: product,
        code: product.code,
        label: product.product_label,
        quantity_ordered: product.quantity_ordered,
        quantity_received: product.quantity_received,
        packaging: product.packaging,
        price: product.price,
        familly: product.familly,
        labelAndOrigin: this.transformLabelAndOrigin(product.label, product.origin),
        tax: product.tax,
        package_number: this.package_number,
      });
      this.resetInputsAndFocus();
      this.$store.dispatch('clearProduct');
      this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.addRowSuccess });
    },
    async saveRow(item) {
      if (item.code.trim() == "" || item.label.trim() == "" || item.familly == null || item.packaging == null || item.quantity_ordered == "") {
        this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.mandatory, mode: 'error'});
        return false;
      }

      const product = await this.findProductOrCreate(item);
      if (product === false) return this.displayToast({ message: messages.deliveries.DeliveryCreate.custom.error, mode: 'error' });
      const data = await this.$store.dispatch('updateDeliveryItem', {
        delivery: this.delivery.id,
        deliveryItem: {
          id: item.id,
          supplier: Number(this.delivery.supplier),
          product: product.product.id,
          price: product.price,
          quantity_ordered: product.quantity_ordered,
          quantity_received: product.quantity_received,
          package_number: product.package_number,
          total: product.price*product.quantity_ordered
        },
        client: this.client
      });
      return data;
    },
    async searchProduct(item) {
      if (!item) {
        if (this.code.trim() === '' || this.delivery.supplier === null) return;
        this.$store.dispatch('searchProduct', { supplier: this.delivery.supplier, code: this.code});
        this.$store.dispatch('setLoading', true);
      } else {
        if (item.code.trim() === '' || this.delivery.supplier === null) return;
        const product = await this.$store.dispatch('searchProduct', { supplier: this.delivery.supplier, code: item.code, isRow: true});

        // Check if product exists & if different from the product stored
        if (product !== false && product != null) {
          // Check here because do not need to empty the object
          if (product.id !== item.product.id) {
            item.product = product;
            item.code = product.code;
            item.label = product.label;
            item.familly = product.Subfamily;
            item.labelAndOrigin = this.transformLabelAndOrigin(product.Label, product.Origin);
            item.quantity_ordered = 1;
            item.quantity_received = 1;
            item.packaging = product.Conditioning;
            item.price = product.price;
            item.tax = product.Tax;
          }
        } else {
          item.product = {};
        }
        item.fingerprint = JSON.stringify({
          code: item.code,
          label: item.label,
          familly: item.familly,
          labelAndOrigin: item.labelAndOrigin,
          packaging: item.packaging,
          price: item.price,
          tax: item.tax
        });
      }
    },
  },
  watch: {
    deliveryData: function(delivery, oldDelivery) {
      if (this.isEdit) {
        this.delivery.id = delivery.id;
        this.delivery.supplier = delivery.supplier_id;
        this.delivery.deliveryDate = new Date(delivery.date);
        this.delivery.deliveryNumber = delivery.code;

        delivery.Delivery_form_data.map(data => {
          const item = {
            id: data.id,
            product: data.Product,
            code: data.Product.code,
            label: data.Product.label,
            quantity_ordered: data.quantity_ordered,
            quantity_received: data.quantity_received,
            packaging: data.Product.Conditioning,
            price: data.Product.price,
            familly: data.Product.Subfamily,
            labelAndOrigin: this.transformLabelAndOrigin(data.Product.Label, data.Product.Origin),
            tax: !!data.Product.Tax ? data.Product.Tax : { percentage: 1 },
            package_number: data.package_number,
          };

          // Create a finger print from the product values, so we can check if the product has changed later
          // And if so create a new one with the new data
          item.fingerprint = JSON.stringify({
            code: item.code,
            label: item.label,
            familly: item.familly,
            labelAndOrigin: item.labelAndOrigin,
            packaging: item.packaging,
            price: item.price,
            tax: !!item.tax ? item.tax : { percentage: 1 }
          });
          this.items.unshift(item);
        });
      }
    },
    product: function (product, oldProduct) {
      if (!product || !product.id) return;
      this.label = product.label;
      this.familly = product.Subfamily;
      this.labelAndOrigin = [
        ...this.product.Label.map(label => ({ ...label, id: `label-${label.id}` })),
        ...this.product.Origin.map(origin => ({ ...origin, id: `origin-${origin.id}` })),
      ];
      this.price = product.price;
      this.tax = product.Tax;
      this.packaging = product.Conditioning;
      this.fingerprint = JSON.stringify({
        code: this.code,
        label: this.label,
        familly: this.familly,
        labelAndOrigin: this.labelAndOrigin,
        packaging: this.packaging,
        price: this.price,
        tax: !!this.tax ? this.tax : { percentage: 1 }
      });
      this.productFound = true;
    },
    newSupplierEntity: function (newSupplier) {
      this.delivery.supplier = newSupplier.id;
    },
    'delivery.supplier': function (newValue, oldValue) {
      if (this.delivery.id) {
        this.$store.dispatch('supplierChanged', true);
      }
    },
  }
};
</script>

<style scoped>
/* Table */
/* Define column width */
col.code { width: 11%; min-width: 110px; }
col.label { width: 39%; }
col.quantity { width: 22%; }
col.price { width: 10%; }
col.total { width: 13%; }
col.add { width: 4%; }

.delivered-items .f-table {
  margin-top: 0.5rem;
}
.deliverycreate .f-table:first-child {
  border-radius: 5px 5px 0 0;
}
.deliverycreate .f-table:first-child th{
  background-color: transparent;
}

.qte-packaging .ab-input { width: 32%; }
.qte-packaging .c-select { width: 70%; }
.qte-packaging .input-quantity { min-width: 1rem; }
.weight { width: 100%; }
.weight .ab-input { width: 32% }
.weight .ab-input.lot { width: 42% }
.weight span.lot { width: 18% }

.action-btn {
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 5px;
}
.action-btn:disabled { color: #cecece; }
.ab-button[disabled], .ab-button[disabled]:hover {
  color: #cecece;
  background: var(--app-light-grey);
  cursor: default;
}
.add-btn { color: var(--app-primary-color); }
.remove-btn { color: var(--app-red-color); }
.save-btn { color: var(--app-primary-color); }

/* Both table */
.input-table {
  border-radius: 5px 5px 0 0; 
}
.delivery-table {
  border-radius: 0 0 5px 5px;
}

.input-form { position: relative; }
.input-form .loading {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  width: 100%;
  min-height: 9rem;
  background-color: rgba(206, 206, 206, 0.5);
  text-align: center;
}

.input-form .loading .f-loader {
  --loader-bg-color: var(--app-primary-color);
  --loader-color: var(--app-secondary-color)
}

/* Modal */
.modal .footer .ab-button:first-child { margin-right: 1rem; }
</style>
<style>
/* Place calendar above datepicker */
.vdp-datepicker__calendar {
  right: 0;
}

/* Selects */
.familly-select, .labels-origins, .labels-origins .multiselect--active { min-width: 12rem; }
.select-packaging { width: 9rem; }
.select-price { width: 6rem; }
</style>
<style scoped src="@/assets/styles/deliveries.css"></style>
<style src="@/assets/styles/datepickers.css"></style>
